import React from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Input } from 'semantic-ui-react';
import { RootConsumer } from '../../RootComponent';
import { SelectableBlock } from '../../Elements';
import { MobileModal } from '../../Modules';
import styles from '../Playlist.scss';

class SelectPlaylist extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    goForward: PropTypes.func.isRequired,
    playlists: PropTypes.array.isRequired,
    selectedPlaylistId: PropTypes.string,
    onPlaylistSelect: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      query: ''
    };
    this.filterByQuery = this.filterByQuery.bind(this);
    this.removeLinks = this.removeLinks.bind(this);
  }

  filterByQuery(playlists) {
    const { query } = this.state;
    return playlists.filter(
      playlist => playlist.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  removeLinks(str) {
    return str.replace(/<\/?a[^>]*>/g, '');
  }

  render() {
    const {
      goForward,
      onClose,
      playlists,
      selectedPlaylistId,
      onPlaylistSelect
    } = this.props;
    const { query } = this.state;
    return (
      <RootConsumer>
        {({ isMobile }) =>
          <div>
            {isMobile &&
              <MobileModal.Header>
                <div className='menu'>
                  <a className='item' onClick={onClose}>
                    Cancel
                  </a>
                </div>
                {selectedPlaylistId &&
                  <div className='menu right'>
                    <a className='item' onClick={goForward}>
                      Next
                    </a>
                  </div>}
              </MobileModal.Header>}
            <h3>Select a playlist</h3>
            <Input
              name='search'
              type='text'
              size='small'
              icon={{
                name: query === '' ? 'search' : 'close',
                onClick: () => this.setState({ query: '' }),
                link: query !== ''
              }}
              placeholder='Filter...'
              onChange={(e) => this.setState({ query: e.target.value })}
              value={query}
              style={{ marginBottom: '1em' }}
            />
            <div
              style={isMobile ? {} : { maxHeight: '300px', overflowY: 'auto' }}
            >
              {this.filterByQuery(playlists).map((playlist, index) =>
                <SelectableBlock
                  key={index}
                  radio
                  checked={selectedPlaylistId === playlist.id}
                  onChange={() => onPlaylistSelect(playlist.id)}
                  style={{ marginBottom: '1em' }}
                >
                  <div style={{ display: 'flex' }}>
                    <div
                      className={styles.songThumbnail}
                      style={{ minWidth: '64px' }}
                    >
                      <Image src='https://mosaic.scdn.co/60/ab67616d0000b273146f0228683dc97769498290ab67616d0000b273365b3fb800c19f7ff72602daab67616d0000b273a6a335d613d151c626895a83ab67616d0000b273d785fa246cca092598fe3c3b' />
                    </div>
                    <div style={{ marginLeft: '1em', wordBreak: 'break-word' }}>
                      <strong>
                        {playlist.name}
                      </strong>
                      {playlist.description !== '' &&
                        <p className={styles.muted} style={{ margin: 0 }}>
                          {this.removeLinks(playlist.description)}
                        </p>}
                    </div>
                  </div>
                </SelectableBlock>
              )}
            </div>
            {!isMobile &&
              <div style={{ marginTop: '2em', textAlign: 'right' }}>
                <span
                  className={styles.muted}
                  style={{ cursor: 'pointer', marginRight: '2em' }}
                  onClick={onClose}
                >
                  Cancel
                </span>
                <Button
                  primary
                  content='Next'
                  disabled={!selectedPlaylistId}
                  onClick={goForward}
                />
              </div>}
          </div>}
      </RootConsumer>
    );
  }
}

export default SelectPlaylist;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Import/SelectPlaylist.js